<script setup lang="ts">
const COLORS = [
  'bg-accent-400',
  'bg-brand-500',
  'bg-accent-300',
  'bg-brand-300',
  'bg-emerald-400',
  'bg-rose-400',
]

const pieces = Array.from({ length: 48 }, (_, index) => ({
  id: index,
  left: `${(index * 17 + 8) % 100}%`,
  delay: `${(index % 12) * 0.07}s`,
  duration: `${2.2 + (index % 7) * 0.18}s`,
  color: COLORS[index % COLORS.length],
  rotate: `${(index * 47) % 360}deg`,
  width: index % 3 === 0 ? '0.45rem' : '0.28rem',
  height: index % 4 === 0 ? '0.7rem' : '0.4rem',
}))
</script>

<template>
  <div class="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
    <span
      v-for="piece in pieces"
      :key="piece.id"
      class="absolute top-[-8%] rounded-sm opacity-90 animate-confetti-fall"
      :class="piece.color"
      :style="{
        left: piece.left,
        width: piece.width,
        height: piece.height,
        animationDelay: piece.delay,
        animationDuration: piece.duration,
        transform: `rotate(${piece.rotate})`,
      }"
    />
  </div>
</template>
